import React from "react";
import { useState } from "react";
import { Box, Flex, Group, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Carousel } from "@mantine/carousel";
import useEmblaCarousel from "embla-carousel-react";

import { ThemedButton } from "./ThemedButton";

const ThemedCarousel = (props: { title: string | React.ReactNode, children: React.ReactNode }) => {
	const isMobile = useMediaQuery("(max-width: 575px)");
	const [emblaRef, emblaApi] = useEmblaCarousel();
	const [currentIndex, setCurrentIndex] = useState(0);
	const totalChildren = React.Children.count(props.children);
	return (
		<Box className={"fadeInDiv"}>
			<Flex
				justify={{ base: "space-between", sm: "center" }}
				px={{ base: 20, sm: 0 }}
				align='center'>
				<>
					<Title order={3} py={20} fz={{ base: 15, xs: 18, sm: 24 }} fw={700}>
						{props.title}
						{currentIndex > 0 && ` (${currentIndex + 1} / ${totalChildren})`}
					</Title>
					<Group hiddenFrom='sm'>
						<ThemedButton
							onClick={() => emblaApi?.scrollPrev()}
							variant='light'
							size='compact-sm'>
							<i className='fa fa-angle-left' />
						</ThemedButton>
						<ThemedButton
							onClick={() => emblaApi?.scrollNext()}
							variant='light'
							size='compact-sm'>
							<i className='fa fa-angle-right' />
						</ThemedButton>
					</Group>
				</>
			</Flex>
			<Carousel withIndicators height={"auto"} ref={emblaRef} withControls={!isMobile} onChange={(index) => setCurrentIndex(index)}>
				{props.children}
			</Carousel>
		</Box>
	);
};

export default ThemedCarousel;
